module.exports = __webpack_public_path__ + "img/img_brand7.045c8934.jpg";